<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card colClasses="xs12" v-if="!firstSteps.allDone">
					<v-layout>
						<v-flex xs12>
							<app-card>
								<h1>{{ $t("message.firstSteps") }}</h1>
								<div
									class="step body-2"
									:class="firstSteps.telegram_store && 'completed'"
								>
									Configura tu
									<span class="link-color" @click="goToTele()"
										>tienda de telegram</span
									>
								</div>
								<div
									class="step body-2"
									:class="firstSteps.dealers && 'completed'"
								>
									Crea <a href="/delivery-dealers">repartidores</a>
								</div>
								<div
									class="step body-2"
									:class="firstSteps.delivery_routes && 'completed'"
								>
									Crea <a href="/delivery-shipping-routes">rutas de envío</a>
								</div>
							</app-card>
						</v-flex>
					</v-layout>
				</app-card>
				<app-card colClasses="xs12">
					<v-form
						@submit="onSubmit"
						ref="storeFormElement"
						v-model="storeForm.valid"
					>
						<v-container>
							<v-layout row wrap>
								<v-flex xs12>
									<h3>{{ $t("message.availability") }}</h3>
									<v-switch
										:label="
											storeForm.isAvailable
												? $t('message.available')
												: $t('message.notAvailable')
										"
										v-model="storeForm.isAvailable"
										color="primary"
										hide-details
									></v-switch>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex xs12>
									<h3>{{ $t("message.info") }}</h3>
								</v-flex>

								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.companyName')"
										data-vv-name="name"
										v-model="storeForm.name"
										v-validate="'min:2|max:50'"
										:error-messages="errors.collect('name')"
									></v-text-field>
								</v-flex>

								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.primaryUserAdministrator')"
										prefix="@"
										v-model="storeForm.telegramAdmin"
									></v-text-field>
								</v-flex>

								<v-flex xs12>
									<v-textarea
										counter="250"
										data-vv-name="description"
										:label="$t('message.description')"
										:rows="1"
										v-model="storeForm.description"
										v-validate="'min:5|max:250'"
										:error-messages="errors.collect('description')"
									></v-textarea>
								</v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12>
									<h3>Administradores</h3>
								</v-flex>
								<v-flex xs9 d-flex align-center>
									<span>Agregue o elimine administradores de telegram.</span>
								</v-flex>
								<v-flex xs3 d-flex align-center v-if="admins.length < 3">
									<v-btn @click="addAdmin">Agregar</v-btn>
								</v-flex>
								<v-flex
									class="admin-container"
									row
									xs12
									v-for="(admin, index) in admins"
									:key="admin.id"
								>
									<v-layout row wrap>
										<v-flex xs11>
											<v-text-field
												label="Nombre de usuario"
												prefix="@"
												v-model="admin.username"
											></v-text-field>
										</v-flex>
										<v-flex xs1>
											<v-btn flat icon @click="removeAdmin(index)">
												<v-icon>delete</v-icon>
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs3>
									<v-btn @click="saveAdmins">Guardar</v-btn>
								</v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12>
									<h3>{{ $t("message.address") }}</h3>
								</v-flex>

								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.country')"
										data-vv-name="country"
										v-model="storeForm.country"
										placeholder="Venezuela"
										disabled
									></v-text-field>
								</v-flex>

								<v-flex xs12 sm6>
									<v-autocomplete
										:label="$t('message.state')"
										v-model="storeForm.state"
										data-vv-name="state"
										:items="states"
										v-validate="'max:50|min:4'"
										:error-messages="errors.collect('state')"
									></v-autocomplete>
								</v-flex>

								<v-flex xs12 sm6>
									<v-autocomplete
										:label="$t('message.city')"
										v-model="storeForm.city"
										data-vv-name="city"
										:items="cities"
										v-validate="'max:50|min:4'"
										:error-messages="errors.collect('city')"
									></v-autocomplete>
								</v-flex>

								<!-- <v-flex xs6>
                  <v-text-field
                    :label="$t('message.address')"
                    data-vv-name="address"
                    v-model="storeForm.address"
                    placeholder="Avenida Intercomunal"
                    v-validate="'max:100|min:5'"
                    :error-messages="errors.collect('address')"
                  ></v-text-field>
                </v-flex>-->

								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.telephone')"
										data-vv-name="phone"
										v-model="storeForm.phone"
										placeholder="+584127877555"
										v-validate="{
											required: false,
											regex: /^(?:(?:00|\+)58|0)(?:2(?:12|4[0-9]|5[1-9]|6[0-9]|7[0-8]|8[1-35-8]|9[1-5]|3[45789])|4(?:1[246]|2[46]))\d{7}$/,
										}"
										:error-messages="errors.collect('phone')"
									></v-text-field>
								</v-flex>

								<v-flex xs12>
									<v-layout align-center wrap>
										<v-flex>
											<v-text-field
												:label="$t('message.latitude')"
												v-model="storeForm.lat"
												disabled
											></v-text-field>
										</v-flex>
										<v-flex>
											<v-text-field
												:label="$t('message.longitude')"
												v-model="storeForm.lng"
												disabled
											></v-text-field>
										</v-flex>

										<v-flex shrink>
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														@click="openMap"
														color="blue"
														dark
														fab
														small
														v-on="on"
													>
														<v-icon dark>add_location</v-icon>
													</v-btn>
												</template>
												<span>{{ $t("message.addLocation") }}</span>
											</v-tooltip>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex xs12>
									<h3 ref="tele">{{ $t("message.telegramBotToken") }}</h3>
								</v-flex>
								<v-flex xs12>
									<v-layout align-center wrap>
										<v-flex>
											<v-text-field
												:error-messages="errors.collect('telegramBotToken')"
												data-vv-name="telegramBotToken"
												:label="$t('message.token')"
												v-model="storeForm.telegramBotToken"
												v-validate="{
													required: true,
													regex: /[0-9]{9}:[a-zA-Z0-9_-]{35}/,
												}"
											></v-text-field>
										</v-flex>
										<v-flex shrink>
											<v-tooltip top>
												<template v-slot:activator="{ on }">
													<a
														class="v-btn v-btn--floating v-btn--router v-btn--small theme--dark warning"
														href="https://docs.microsoft.com/es-mx/azure/bot-service/bot-service-channel-connect-telegram?view=azure-bot-service-4.0"
														target="_blank"
														v-on="on"
													>
														<v-icon dark>zmdi-help</v-icon>
													</a>
												</template>
												<span>{{ $t("message.howCreateBot") }}</span>
											</v-tooltip>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>

							<v-spacer></v-spacer>
							<v-layout justify-end row>
								<!-- <router-link to="/dashboard">
                  <v-btn outline color="error">{{ $t('message.back') }}</v-btn>
                </router-link>-->
								<v-btn outline @click="onSubmit" color="primary">{{
									$t("message.save")
								}}</v-btn>
							</v-layout>
						</v-container>
					</v-form>
				</app-card>
			</v-layout>
		</v-container>
		<v-map
			:dialog.sync="showMap"
			@position="setPosition"
			ref="mapComponent"
		></v-map>
		<notifications
			group="updateStore"
			width="350px"
			position="top right"
			animation-type="velocity"
		/>
	</div>
</template>

<script>
import api from "../../../api/apibackend";
import Map from "../../store/Map";
import { mapGetters } from "vuex";
import {
	GET_DELIVERY_COMPANY,
	UPDATE_DELIVERY_COMPANY,
} from "../../../store/modules/delivery/company/actions.type";
import Vue from "vue";

export default {
	name: "deliveryProfile",
	components: {
		VMap: Map,
	},
	data: () => {
		return {
			exchangeRate: 0,
			statesWithCities: [
				{
					ciudades: ["Maroa", "Puerto Ayacucho", "San Fernando de Atabapo"],
					estado: "Amazonas",
				},
				{
					ciudades: [
						"Anaco",
						"Aragua de Barcelona",
						"Barcelona",
						"Boca de Uchire",
						"Cantaura",
						"Clarines",
						"El Chaparro",
						"El Pao Anzoátegui",
						"El Tigre",
						"El Tigrito",
						"Guanape",
						"Guanta",
						"Lechería",
						"Onoto",
						"Pariaguán",
						"Píritu",
						"Puerto La Cruz",
						"Puerto Píritu",
						"Sabana de Uchire",
						"San Mateo Anzoátegui",
						"San Pablo Anzoátegui",
						"San Tomé",
						"Santa Ana de Anzoátegui",
						"Santa Fe Anzoátegui",
						"Santa Rosa",
						"Soledad",
						"Urica",
						"Valle de Guanape",
					],
					estado: "Anzoátegui",
				},
				{
					ciudades: [
						"Achaguas",
						"Biruaca",
						"Bruzual",
						"El Amparo",
						"El Nula",
						"Elorza",
						"Guasdualito",
						"Mantecal",
						"Puerto Páez",
						"San Fernando de Apure",
						"San Juan de Payara",
					],
					estado: "Apure",
				},
				{
					ciudades: [
						"Barbacoas",
						"Cagua",
						"Camatagua",
						"Choroní",
						"Colonia Tovar",
						"El Consejo",
						"La Victoria",
						"Las Tejerías",
						"Magdaleno",
						"Maracay",
						"Ocumare de La Costa",
						"Palo Negro",
						"San Casimiro",
						"San Mateo",
						"San Sebastián",
						"Santa Cruz de Aragua",
						"Tocorón",
						"Turmero",
						"Villa de Cura",
						"Zuata",
					],
					estado: "Aragua",
				},
				{
					ciudades: [
						"Barinas",
						"Barinitas",
						"Barrancas",
						"Calderas",
						"Capitanejo",
						"Ciudad Bolivia",
						"El Cantón",
						"Las Veguitas",
						"Libertad de Barinas",
						"Sabaneta",
						"Santa Bárbara de Barinas",
						"Socopó",
					],
					estado: "Barinas",
				},
				{
					ciudades: [
						"Caicara del Orinoco",
						"Canaima",
						"Ciudad Bolívar",
						"Ciudad Piar",
						"El Callao",
						"El Dorado",
						"El Manteco",
						"El Palmar",
						"El Pao",
						"Guasipati",
						"Guri",
						"La Paragua",
						"Matanzas",
						"Puerto Ordaz",
						"San Félix",
						"Santa Elena de Uairén",
						"Tumeremo",
						"Unare",
						"Upata",
					],
					estado: "Bolívar",
				},
				{
					ciudades: [
						"Bejuma",
						"Belén",
						"Campo de Carabobo",
						"Canoabo",
						"Central Tacarigua",
						"Chirgua",
						"Ciudad Alianza",
						"El Palito",
						"Guacara",
						"Guigue",
						"Las Trincheras",
						"Los Guayos",
						"Mariara",
						"Miranda",
						"Montalbán",
						"Morón",
						"Naguanagua",
						"Puerto Cabello",
						"San Joaquín",
						"Tocuyito",
						"Urama",
						"Valencia",
						"Vigirimita",
					],
					estado: "Carabobo",
				},
				{
					ciudades: [
						"Aguirre",
						"Apartaderos Cojedes",
						"Arismendi",
						"Camuriquito",
						"El Baúl",
						"El Limón",
						"El Pao Cojedes",
						"El Socorro",
						"La Aguadita",
						"Las Vegas",
						"Libertad de Cojedes",
						"Mapuey",
						"Piñedo",
						"Samancito",
						"San Carlos",
						"Sucre",
						"Tinaco",
						"Tinaquillo",
						"Vallecito",
					],
					estado: "Cojedes",
				},
				{
					ciudades: ["Tucupita"],
					estado: "Delta Amacuro",
				},
				{
					ciudades: [
						"Adícora",
						"Boca de Aroa",
						"Cabure",
						"Capadare",
						"Capatárida",
						"Chichiriviche",
						"Churuguara",
						"Coro",
						"Cumarebo",
						"Dabajuro",
						"Judibana",
						"La Cruz de Taratara",
						"La Vela de Coro",
						"Los Taques",
						"Maparari",
						"Mene de Mauroa",
						"Mirimire",
						"Pedregal",
						"Píritu Falcón",
						"Pueblo Nuevo Falcón",
						"Puerto Cumarebo",
						"Punta Cardón",
						"Punto Fijo",
						"San Juan de Los Cayos",
						"San Luis",
						"Santa Ana Falcón",
						"Santa Cruz De Bucaral",
						"Tocopero",
						"Tocuyo de La Costa",
						"Tucacas",
						"Yaracal",
					],
					estado: "Falcón",
				},
				{
					ciudades: [
						"Altagracia de Orituco",
						"Cabruta",
						"Calabozo",
						"Camaguán",
						"Chaguaramas Guárico",
						"El Socorro",
						"El Sombrero",
						"Las Mercedes de Los Llanos",
						"Lezama",
						"Onoto",
						"Ortíz",
						"San José de Guaribe",
						"San Juan de Los Morros",
						"San Rafael de Laya",
						"Santa María de Ipire",
						"Tucupido",
						"Valle de La Pascua",
						"Zaraza",
					],
					estado: "Guárico",
				},
				{
					ciudades: [
						"Aguada Grande",
						"Atarigua",
						"Barquisimeto",
						"Bobare",
						"Cabudare",
						"Carora",
						"Cubiro",
						"Cují",
						"Duaca",
						"El Manzano",
						"El Tocuyo",
						"Guaríco",
						"Humocaro Alto",
						"Humocaro Bajo",
						"La Miel",
						"Moroturo",
						"Quíbor",
						"Río Claro",
						"Sanare",
						"Santa Inés",
						"Sarare",
						"Siquisique",
						"Tintorero",
					],
					estado: "Lara",
				},
				{
					ciudades: [
						"Apartaderos Mérida",
						"Arapuey",
						"Bailadores",
						"Caja Seca",
						"Canaguá",
						"Chachopo",
						"Chiguara",
						"Ejido",
						"El Vigía",
						"La Azulita",
						"La Playa",
						"Lagunillas Mérida",
						"Mérida",
						"Mesa de Bolívar",
						"Mucuchíes",
						"Mucujepe",
						"Mucuruba",
						"Nueva Bolivia",
						"Palmarito",
						"Pueblo Llano",
						"Santa Cruz de Mora",
						"Santa Elena de Arenales",
						"Santo Domingo",
						"Tabáy",
						"Timotes",
						"Torondoy",
						"Tovar",
						"Tucani",
						"Zea",
					],
					estado: "Mérida",
				},
				{
					ciudades: [
						"Araguita",
						"Carrizal",
						"Caucagua",
						"Chaguaramas Miranda",
						"Charallave",
						"Chirimena",
						"Chuspa",
						"Cúa",
						"Cupira",
						"Curiepe",
						"El Guapo",
						"El Jarillo",
						"Filas de Mariche",
						"Guarenas",
						"Guatire",
						"Higuerote",
						"Los Anaucos",
						"Los Teques",
						"Ocumare del Tuy",
						"Panaquire",
						"Paracotos",
						"Río Chico",
						"San Antonio de Los Altos",
						"San Diego de Los Altos",
						"San Fernando del Guapo",
						"San Francisco de Yare",
						"San José de Los Altos",
						"San José de Río Chico",
						"San Pedro de Los Altos",
						"Santa Lucía",
						"Santa Teresa",
						"Tacarigua de La Laguna",
						"Tacarigua de Mamporal",
						"Tácata",
						"Turumo",
					],
					estado: "Miranda",
				},
				{
					ciudades: [
						"Aguasay",
						"Aragua de Maturín",
						"Barrancas del Orinoco",
						"Caicara de Maturín",
						"Caripe",
						"Caripito",
						"Chaguaramal",
						"Chaguaramas Monagas",
						"El Furrial",
						"El Tejero",
						"Jusepín",
						"La Toscana",
						"Maturín",
						"Miraflores",
						"Punta de Mata",
						"Quiriquire",
						"San Antonio de Maturín",
						"San Vicente Monagas",
						"Santa Bárbara",
						"Temblador",
						"Teresen",
						"Uracoa",
					],
					estado: "Monagas",
				},
				{
					ciudades: [
						"Altagracia",
						"Boca de Pozo",
						"Boca de Río",
						"El Espinal",
						"El Valle del Espíritu Santo",
						"El Yaque",
						"Juangriego",
						"La Asunción",
						"La Guardia",
						"Pampatar",
						"Porlamar",
						"Puerto Fermín",
						"Punta de Piedras",
						"San Francisco de Macanao",
						"San Juan Bautista",
						"San Pedro de Coche",
						"Santa Ana de Nueva Esparta",
						"Villa Rosa",
					],
					estado: "Nueva Esparta",
				},
				{
					ciudades: [
						"Acarigua",
						"Agua Blanca",
						"Araure",
						"Biscucuy",
						"Boconoito",
						"Campo Elías",
						"Chabasquén",
						"Guanare",
						"Guanarito",
						"La Aparición",
						"La Misión",
						"Mesa de Cavacas",
						"Ospino",
						"Papelón",
						"Payara",
						"Pimpinela",
						"Píritu de Portuguesa",
						"San Rafael de Onoto",
						"Santa Rosalía",
						"Turén",
					],
					estado: "Portuguesa",
				},
				{
					ciudades: [
						"Altos de Sucre",
						"Araya",
						"Cariaco",
						"Carúpano",
						"Casanay",
						"Cumaná",
						"Cumanacoa",
						"El Morro Puerto Santo",
						"El Pilar",
						"El Poblado",
						"Guaca",
						"Guiria",
						"Irapa",
						"Manicuare",
						"Mariguitar",
						"Río Caribe",
						"San Antonio del Golfo",
						"San José de Aerocuar",
						"San Vicente de Sucre",
						"Santa Fe de Sucre",
						"Tunapuy",
						"Yaguaraparo",
						"Yoco",
					],
					estado: "Sucre",
				},
				{
					ciudades: [
						"Abejales",
						"Borota",
						"Bramon",
						"Capacho",
						"Colón",
						"Coloncito",
						"Cordero",
						"El Cobre",
						"El Pinal",
						"Independencia",
						"La Fría",
						"La Grita",
						"La Pedrera",
						"La Tendida",
						"Las Delicias",
						"Las Hernández",
						"Lobatera",
						"Michelena",
						"Palmira",
						"Pregonero",
						"Queniquea",
						"Rubio",
						"San Antonio del Tachira",
						"San Cristobal",
						"San José de Bolívar",
						"San Josecito",
						"San Pedro del Río",
						"Santa Ana Táchira",
						"Seboruco",
						"Táriba",
						"Umuquena",
					],
					estado: "Táchira",
				},
				{
					ciudades: [
						"Batatal",
						"Betijoque",
						"Boconó",
						"Carache",
						"Chejende",
						"Cuicas",
						"El Dividive",
						"El Jaguito",
						"Escuque",
						"Isnotú",
						"Jajó",
						"La Ceiba",
						"La Concepción de Trujllo",
						"La Mesa de Esnujaque",
						"La Puerta",
						"La Quebrada",
						"Mendoza Fría",
						"Meseta de Chimpire",
						"Monay",
						"Motatán",
						"Pampán",
						"Pampanito",
						"Sabana de Mendoza",
						"San Lázaro",
						"Santa Ana de Trujillo",
						"Tostós",
						"Trujillo",
						"Valera",
					],
					estado: "Trujillo",
				},
				{
					ciudades: ["Carayaca", "Litoral"],
					estado: "Vargas",
				},
				{
					ciudades: [
						"Aroa",
						"Boraure",
						"Campo Elías de Yaracuy",
						"Chivacoa",
						"Cocorote",
						"Farriar",
						"Guama",
						"Marín",
						"Nirgua",
						"Sabana de Parra",
						"Salom",
						"San Felipe",
						"San Pablo de Yaracuy",
						"Urachiche",
						"Yaritagua",
						"Yumare",
					],
					estado: "Yaracuy",
				},
				{
					ciudades: [
						"Bachaquero",
						"Bobures",
						"Cabimas",
						"Campo Concepción",
						"Campo Mara",
						"Campo Rojo",
						"Carrasquero",
						"Casigua",
						"Chiquinquirá",
						"Ciudad Ojeda",
						"El Batey",
						"El Carmelo",
						"El Chivo",
						"El Guayabo",
						"El Mene",
						"El Venado",
						"Encontrados",
						"Gibraltar",
						"Isla de Toas",
						"La Concepción",
						"La Paz",
						"La Sierrita",
						"Lagunillas",
						"Las Piedras",
						"Los Cortijos",
						"Machiques",
						"Maracaibo",
						"Mene Grande",
						"Palmarejo",
						"Paraguaipoa",
						"Potrerito",
						"Pueblo Nuevo",
						"Puertos de Altagracia",
						"Punta Gorda",
						"Sabaneta de Palma",
						"San Francisco",
						"San José de Perijá",
						"San Rafael del Moján",
						"San Timoteo",
						"Santa Bárbara del Zulia",
						"Santa Cruz de Mara",
						"Santa Cruz del Zulia",
						"Santa Rita",
						"Sinamaica",
						"Tamare",
						"Tía Juana",
						"Villa Rosario",
					],
					estado: "Zulia",
				},
				{
					ciudades: ["Caracas"],
					estado: "Distrito Capital",
				},
			],
			states: [
				"Amazonas",
				"Anzoátegui",
				"Apure",
				"Aragua",
				"Barinas",
				"Bolívar",
				"Carabobo",
				"Cojedes",
				"Delta Amacuro",
				"Falcón",
				"Guárico",
				"Lara",
				"Mérida",
				"Miranda",
				"Monagas",
				"Nueva Esparta",
				"Portuguesa",
				"Sucre",
				"Táchira",
				"Trujillo",
				"Vargas",
				"Yaracuy",
				"Zulia",
				"Distrito Capital",
			],
			storeForm: {
				valid: false,
				hasManualRate: false,
				name: "",
				description: "",
				telegramUserBot: "",
				dollarPercentage: 0,
				dollarPrice: 0,
				address: "",
				state: "",
				city: "",
				phone: "",
				lng: null,
				lat: null,
				country: "Venezuela",
				telegramId: null,
				telegramAdmin: null,
				telegramBotToken: null,
				isAvailable: true,
			},
			isLoading: false,
			isCreate: false,
			showMap: false,
			admins: [],
			priceRules: [
				(v) => !!v || this.$t("message.errorPrice"),
				(v) =>
					/^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(v) ||
					this.$t("message.errorQuantity"),
			],
		};
	},
	computed: {
		...mapGetters(["deliveryCompany"]),
		firstSteps() {
			let steps = {
				dealers: false,
				delivery_routes: false,
				telegram_store: false,
				allDone: false,
			};

			if (this.deliveryCompany && this.deliveryCompany.company_validation) {
				steps = {
					dealers: this.deliveryCompany.company_validation.dealers,
					delivery_routes: this.deliveryCompany.company_validation
						.delivery_routes,
					telegram_store: this.deliveryCompany.company_validation
						.telegram_store,
					allDone: false,
				};
			}

			steps.allDone =
				steps.dealers && steps.delivery_routes && steps.telegram_store;

			return steps;
		},
		cities() {
			if (this.storeForm.state) {
				return this.statesWithCities.filter(
					(element) => element.estado === this.storeForm.state
				)[0].ciudades;
			}
		},
		ratePreview() {
			if (this.storeForm.hasManualRate) {
				return this.storeForm.dollarPrice || "";
			}

			return `${Math.ceil(
				this.exchangeRate * this.storeForm.dollarPercentage * 0.01 +
					this.exchangeRate
			).toLocaleString()} VES`;
		},
	},
	mounted() {
		this.getDeliveryCompany();
		this.getExchangeRate();
	},
	updated() {
		if (this.deliveryCompany && this.admins.length === 0) this.getAdmins();
	},
	methods: {
		goToTele() {
			let element = this.$refs.tele;
			element.scrollIntoView();
		},
		getDeliveryCompany() {
			this.$store.dispatch(GET_DELIVERY_COMPANY).then(() => {
				this.storeForm.isAvailable = this.deliveryCompany.show;
				this.storeForm.name = this.deliveryCompany.name;
				this.storeForm.description = this.deliveryCompany.description;

				this.storeForm.telegramBotToken = this.deliveryCompany.telegram_bot_token;
				this.storeForm.telegramUserBot = this.deliveryCompany.telegramUserBot;
				this.storeForm.telegramAdmin = this.deliveryCompany.admin_telegram_user;
				this.storeForm.telegramId = this.deliveryCompany.admin_telegram_id;

				this.storeForm.lng = this.deliveryCompany.longitude;
				this.storeForm.lat = this.deliveryCompany.latitude;
				this.storeForm.dollarPercentage = this.deliveryCompany.dollar_percent;
				this.storeForm.dollarPrice = this.deliveryCompany.dollar_price;
				this.storeForm.hasManualRate = this.deliveryCompany.dollar_price
					? true
					: false;

				this.storeForm.city = this.deliveryCompany.city;
				this.storeForm.state = this.deliveryCompany.state;
				//this.storeForm.address = this.deliveryCompany.street_address;
				this.storeForm.phone = this.deliveryCompany.phone;
			});
		},
		async onSubmit() {
			try {
				const valid = await this.$validator.validateAll();

				if (valid) {
					let storeData = {
						name: this.storeForm.name,
						description: this.storeForm.description,
						dollar_percent: this.storeForm.dollarPercentage,
						dollar_price: this.storeForm.dollarPrice,
						state: this.storeForm.state,
						city: this.storeForm.city,
						street_address: this.storeForm.address,
						country: this.storeForm.country,
						phone: this.storeForm.phone,
						telegram_bot_token: this.storeForm.telegramBotToken,
						telegram_user_bot: this.storeForm.telegramUserBot,
						admin_telegram_user: this.storeForm.telegramAdmin,
						show: this.storeForm.isAvailable,
					};

					if (!this.storeForm.hasManualRate) {
						storeData.dollar_price = null;
					}

					if (this.storeForm.lng && this.storeForm.lat) {
						storeData.latitude = this.storeForm.lat;
						storeData.longitude = this.storeForm.lng;
					}

					// this.$store.dispatch(UPDATE_STORE, storeData).then(res => {
					//   if (res) {
					//     setTimeout(() => {
					//       this.$router.push("/dashboard");
					//     }, 2000);
					//   }
					// });

					this.$store.dispatch(UPDATE_DELIVERY_COMPANY, storeData);
				}
			} catch (err) {
				console.error(err);
			}
		},
		setPosition(position) {
			this.storeForm.lng = position.lng;
			this.storeForm.lat = position.lat;
		},
		openMap() {
			if (this.storeForm.lng && this.storeForm.lat) {
				this.$refs.mapComponent.setPosition(
					this.storeForm.lat,
					this.storeForm.lng
				);
			}
			this.showMap = true;
			this.$refs.mapComponent.callMapInvalidateSize();
		},
		getExchangeRate() {
			api
				.get("https://api.tubotones.com/api/dollar", {})
				.then((res) => {
					this.exchangeRate = res.data.rate;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getAdmins() {
			api
				.get(`company/telegram_admins/${this.deliveryCompany.id}`)
				.then((response) => {
					this.admins = response.data;
				});
		},
		addAdmin() {
			if (this.admins.length >= 3) {
				return;
			}
			this.admins.push({
				username: "",
			});
		},
		removeAdmin(index) {
			this.admins = [
				...this.admins.slice(0, index),
				...this.admins.slice(index + 1),
			];
		},
		saveAdmins() {
			api
				.post(`company/telegram_admins/${this.deliveryCompany.id}`, {
					admins: this.admins.filter((admin) => admin.username.length > 0),
				})
				.then((res) => {
					Vue.notify({
						group: "loggedIn",
						type: "success",
						text: res.data,
					}).catch((e) => {
						Vue.notify({
							text: e.message,
							tipe: "error",
						});
					});
				});
		},
	},
};
</script>

<style>
.link-color {
	color: #5d92f4;
	cursor: pointer;
}
.completed.step::before {
	content: "✔️";
}
.completed.step,
.completed.step a {
	text-decoration: line-through;
}
</style>
